import * as commonScripts from '../common'
import 'whatwg-fetch'

const cmpStrategyDetailDetailArticle = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)
    const main = _.component.querySelector('.cmp-strategy-detail-detail-article__main')
    const panel = _.component.querySelectorAll('.cmp-strategy-detail-detail-article__panel')
    const pmPanel = _.component.querySelectorAll('.cmp-strategy-detail-detail-article__pmpanel')
    const filter = _.component.querySelector('#filter')

	// if we have more than one strategy panel AND a value in the url hash
	// show the appropriate panel and set the drop down value
    if (panel.length > 1 && window.location.hash) {
      let selectedvalue = window.location.hash.substring(1);
      if (selectedvalue != null) {
		let selectedPanel = main.querySelector('[data-strategy-name="' + selectedvalue + '"]');
		let selectedId = selectedPanel.id;

		selectedPanel.style.display = 'block';
        _.component.querySelector('[data-strategy-name="' + selectedvalue + '"]').style.display = 'block'

		filter.value = selectedId;
      }
    }

	// otherwise, just show the first panel
    else {
      if (panel.length > 0) {
        panel[0].style.display = 'block'
      }
      if (pmPanel.length > 0) {
        pmPanel[0].style.display = 'block'
      }
    }

    if (filter) {
      filter.addEventListener('change', function () {
		// add the selected value to the url hash
		let selected = filter.options[filter.selectedIndex];
		let selectedText = selected.text;
		_.urlHash = selectedText.toLowerCase().replaceAll(/[\s\.]/g, '-');
		window.location.hash = _.urlHash;

        panel.forEach(el => {
          el.style.display = 'none'
        })

        pmPanel.forEach(el => {
          el.style.display = 'none'
        })

        main.querySelector('#' + this.value).style.display = this.value ? 'block' : 'none'
        _.component.querySelector('#pm' + this.value).style.display = this.value ? 'block' : 'none'
		
      }, false)
    }
  }
}

export default cmpStrategyDetailDetailArticle
